.newGamePanel {
    margin-right: 15px;
    overflow-wrap: break-word;
}
